import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { calender_icon } from "../../assets/img";

const DateRange3 = ({ selectedDate, setSelectedDate }) => {
  const formatDate = (date) => {
    if (!date) return null;
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const disableScroll = () => {
    document.documentElement.style.overflow = "hidden"; // <html>
    document.body.style.overflow = "hidden";
  };

  const enableScroll = () => {
    document.documentElement.style.overflow = "";
    document.body.style.overflow = "";
  };

  return (
    <div className="d-flex ac-js position-relative">
      <div className="d-flex ac-js calender-input4 w-100">
        <img
          src={calender_icon}
          className="calender-icon4 mx-2"
          alt="calendar"
          onClick={() => document.getElementById("fromDatePicker").focus()}
        />

        <DatePicker
          id="fromDatePicker"
          selected={selectedDate ? new Date(selectedDate) : null}
          onChange={(date) => setSelectedDate(formatDate(date))}
          dateFormat="dd-MM-yyyy"
          placeholderText="Select Date"
          className="date-input4"
          maxDate={new Date()}
          withPortal
          onCalendarOpen={disableScroll}
          onCalendarClose={enableScroll}
        />
      </div>

      <div className="search-btn4 fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 sec f3">
        Search
      </div>
    </div>
  );
};

export default DateRange3;
